import React, { memo } from 'react'
import { FormGrid, FormRow, FormLabel, TextInput, FieldError } from '../../components/ui'

/* Só os campos: a casca do modal (cabeçalho, rodapé e o próprio <form>)
   vem do componente FormModal, igual em todas as telas. */
const Form = ({ values, errors, touched, handleChange, handleBlur }) => (
  <FormGrid>
      <FormRow $full>
        <FormLabel>Nome</FormLabel>
        <TextInput autoComplete='nope' name='name' value={values.name || ''}
          onChange={handleChange} onBlur={handleBlur} $error={!!errors.name} />
        <FieldError>{touched.name && errors.name}</FieldError>
      </FormRow>
  </FormGrid>
)

export default memo(Form)
